// wrapper for vendor/pagination

bq.pagination = function(element, options) {
  this.options   = options;
  this.$element  = $(element);
  this.$ul = this.$element.find('ul');
  this.currentPage = 1;
  this.totalPages = 1;
};

bq.pagination.DEFAULTS = {
  currentPage: 1,
  totalPages: 1,
  listnerContainer: false,
  size: 'normal', //large,normal, small
  alignment: 'left', //left, center, right
  pageShown: 5,
  centerCurrentPage: true,
  showFirst: true,
  showLast: true,
  showPrev: true,
  showNext: true,
  tooltips: false,
  tooltipFirst: 'Go to First Page',
  tooltipLast: 'Go to Last Page',
  tooltipPrev: 'Go to Previous Page',
  tooltipNext: 'Go to Next Page',
  tooltipPage: 'Go to Page ',
  tooltipHtml: true,
  tooltipLocation: 'top',
  textFirst: '<span class="fa fa-angle-double-left"></span>',
  textLast: '<span class="fa fa-angle-double-right"></span>',
  textPage: '',
  textPrev: '<span class="fa fa-angle-left"></span>',
  textNext: '<span class="fa fa-angle-right"></span>'
};

bq.pagination.prototype = {
  init: function() {
    bq.debug.log("pagination : init()", this.$element);

    this.currentPage = this.options.currentPage;
    this.totalPages = this.options.totalPages;

    if(this.options.listnerContainer) {
      this.listner = this.$element.closest(this.options.listnerContainer);
    } else {
      this.listner = this.$element.parent();
    }
    //catching events incase there are multiple on the page
    this.listner.on('page-changed', {thiz: this},  this.changed);

    //catch event of parent saying something has changed
    this.listner.on('bq.pagination.update', {thiz: this},  this.update);
    this.throwEventReady();
  },

  update: function(e, totalPages, currentPage) {
    bq.debug.log("pagination : event caught [bq.pagination.update]", totalPages, currentPage);

    var $this = e.data.thiz;

    if($this.totalPages >= 1) {
      $this.create();
    }

    var currentStatus = $this.$ul.bootstrapPaginator("getPages");

    //this update comes from somewhere else
     if(currentPage == currentStatus.current && totalPages == currentStatus.total) {
        //we currently match
        $this.currentPage = currentStatus.current;
        $this.totalPages = currentStatus.total;
     } else {
        $this.currentPage = currentPage;
        $this.totalPages = totalPages;

        var options = {
          currentPage: $this.currentPage,
          totalPages: $this.totalPages
        };

        //update this pagination to match options
        $this.$ul.bootstrapPaginator(options);
        //we dont have to throw an event since the updates above will
     }
  },

  changed: function(e, op, np) {
    bq.debug.log("pagination : event caught [page-changed]", op, np);

    var $this = e.data.thiz;

    var currentStatus = $this.$ul.bootstrapPaginator("getPages");
    if(np == currentStatus.current && $this.totalPages == currentStatus.total) {

      //this is the one that was clicked, throw trigger and exit
      $this.currentPage = currentStatus.current;
      $this.totalPages = currentStatus.total;

      $this.throwChangedEvent(e, op, np);

      return;
    } else {

       //this one is out of sync
      $this.currentPage = np;
      $this.totalPages = currentStatus.total;

      //we wont throw an event since this will trigger an event
      //that will be caught next time through
      var options = {
        currentPage: $this.currentPage,
        totalPages: $this.totalPages
      };

      //update this pagination to match options
      $this.$ul.bootstrapPaginator(options);

    }

  },

  throwEventReady: function() {
     bq.debug.log("pagination : event thrown [bq.pagination.ready]");

    //throws trigger (e)
    this.$ul.trigger('bq.pagination.ready');
  },

  throwChangedEvent: function(e, op, np) {
    bq.debug.log("pagination : event thrown [bq.pagination.changed]", op, np);

    //throws trigger (e, oldevent, oldpage, newpage)
    this.$ul.trigger('bq.pagination.changed', [e, op, np]);
  },

  create: function() {
    var options = {
          currentPage: this.options.currentPage,
          totalPages: this.options.totalPages,
          bootstrapMajorVersion: 3,
          size: this.options.size,
          alignment: this.options.alignment,
          numberOfPages: this.options.pageShown,
          useBootstrapTooltip: this.options.tooltips,
          itemTexts: this.itemTextCallback,
          shouldShowPage: this.showPageCallback,
          tooltipTitles: this.tooltipCallback,
          centerCurrentPage: this.options.centerCurrentPage,
          /*bootstrapTooltipOptions: {
              html: this.options.tooltipHtml,
              placement: this.options.tooltipLocation
          },*/
          pageUrl: function(type, page, current){
              return "javascript:void(0);"; //"http://example.com/list/page/"+page;
          },
          itemContainerClass: function (type, page, current) {
              if(page === current && type === "page") { return "active"; }
              if(type === "first" || type==="prev" && current == 1) { return "disabled"; }
              if(type === "last" || type==="next" && current == this.totalPages) { return "disabled"; }
          },
          ref: this
      };

      this.$ul.bootstrapPaginator(options);
  },

  itemTextCallback: function (type, page, current) {
    var $this = this.ref;
    switch (type) {
      case "first":
        return $this.options.textFirst;
      case "prev":
        return $this.options.textPrev;
      case "next":
        return $this.options.textNext;
      case "last":
        return $this.options.textLast;
      case "page":
        return $this.options.textPage + page;
    }

  },

  showPageCallback: function(type, page, current){
    var $this = this.options.ref;
    switch(type) {
      case "first":
          return $this.options.showFirst;
      case "prev":
          return $this.options.showPrev;
      case "next":
          return $this.options.showNext;
      case "last":
          return $this.options.showLast;
      default:
          return true;
    }
  },

  tooltipCallback: function (type, page, current) {
    var $this = this.ref;
    switch (type) {
      case "first":
        return $this.options.tooltipFirst;
      case "prev":
        return $this.options.tooltipPrev;
      case "next":
        return $this.options.tooltipNext;
      case "last":
        return $this.options.tooltipLast;
      case "page":
        return $this.options.tooltipPage + page;
    }
  }


};

// PAGINATION PLUGIN DEFINITION
// =======================

var bqpaginationold = $.fn.bqpagination;

$.fn.bqpagination = function (option, _relatedTarget) {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.pagination');
    var options = $.extend({}, bq.pagination.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

    if (!data) { $this.data('bq.pagination', (data = new bq.pagination(this, options))); }
    data.init();
  });
};

$.fn.bqpagination.Constructor = bq.pagination;

// PAGINATION NO CONFLICT
// =================

$.fn.bqpagination.noConflict = function () {
  $.fn.bqpagination = bqpaginationold;
  return this;
};

// PAGINATION DATA-API
// ==============

bq.bqpaginationInit = function() {
  $('[data-bq="pagination"]').each(function () {
    var el = $(this);
    if(el.data('bq.pagination')) { return; }
    el.bqpagination(el.data());
  });
};

bq.init.push(bq.bqpaginationInit);
